// Angular imports
import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy, inject } from '@angular/core';

// Project libraries
import { UserData } from '@tgx/shared/interfaces';
import { AuthService } from '@tgx/shared/services';
import { getHeaderMenuUserName, setBackgroundBadge } from '@tgx/shared/utils';

@Component({
  selector: 'tgx-onboarding-company-header',
  templateUrl: './onboarding-company-header.component.html',
  styleUrls: ['./onboarding-company-header.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class OnboardingCompanyHeaderComponent implements OnInit {
  private authService = inject(AuthService);

  @Input() companyName: string;
  @Input() userImg: string;
  @Input() loggedUser: UserData;
  @Input() isBuyer: boolean;
  @Input() isSeller: boolean;

  protected userName: string;
  protected statusUserRoleBackgroundBadge: string;

  ngOnInit(): void {
    this.userName = getHeaderMenuUserName(this.loggedUser);
    this.statusUserRoleBackgroundBadge = setBackgroundBadge(this.loggedUser?.role);
  }

  protected async signOut(): Promise<void> {
    await this.authService.logout();
  }
}
